import { BaseModel } from './base.model';

export interface Profile {
    id: number;
    description: string;
}

export class Profile implements BaseModel {
    id: number;
    description: string;

    constructor();
    constructor(id: number, description: string);
  
    constructor(id?: number, description?: string) {
      if (id !== undefined) {
        this.id = id;
      }
      
      if (description !== undefined) {
        this.description = description;
      } else {
        this.description = '';
      }
    }

    getApiName(): string {
      return 'profiles';
    }

    getName(): string {
      return 'Perfil';
    }
  
    getNamePl(): string {
      return 'Perfiles';
    }
  }